import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const reportingEnrollmentBySessionAPI = async (params: {
  sessionId: string;
  format: string;
}) => {
  const response = await baseAPI.get<string>(
    '/reporting/session-enrollment-report',
    {
      params,
      // responseType: 'text',
    },
  );
  return response.data;
};

export const useReportingEnrollmentBySession = (params: {
  sessionId: string;
  format: string;
}) => {
  return useQuery({
    queryKey: [KEYS.SESSION_ENROLLMENT_REPORT, params.sessionId, params.format],
    queryFn: () => reportingEnrollmentBySessionAPI(params),
    enabled: !!params.sessionId && !!params.format,
  });
};
